<template>
  <F360Callout class="insights-ia-info-callout">
    <img
      :src="iaIcon"
      alt="informação"
      class="insights-ia-info-callout__icon"
    />
    <p>
      Estas sugestões foram criadas automaticamente pela nossa inteligência
      artificial com base nas informações que você inseriu na F360. Para que as
      análises sejam precisas e úteis, é muito importante que seus dados estejam
      completos e corretos. Sempre valide os resultados antes de tomar decisões.
    </p>
  </F360Callout>
</template>

<script setup lang="ts">
import F360Callout from "@/ui/components/Banners/Callout/F360Callout.vue";
import iaIcon from "@/ui/assets/financas/insigths/icone-ia-blue.svg";
</script>

<style scoped lang="scss">
.insights-ia-info-callout {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin: 16px 0 0;
  padding: 14px 16px;
  border: 0;
  border-radius: 4px;
  background: _map.get($map: $neutro, $key: 50);

  &__icon {
    flex: 0 0 auto;
    color: _map.get($map: $azulPrincipal, $key: 700);
    width: 20px;
  }

  p {
    margin: 0;
    color: _map.get($map: $neutro, $key: 900);
    font-size: 12px;
    line-height: 18px;
  }

  @media screen and (max-width: 768px) {
    align-items: flex-start;
  }
}
</style>
